import { Service } from './Service';
import { Country } from './Country';
import { SafeHtml } from '@angular/platform-browser';

/**
 * model for the one to many relationship between Disaster and Country, with additional data
 */
export interface DisasterCountry {
  country?: Country;
  entireCountry?: boolean;
  // describes the area affected by the disaster. these fields are optional.
  geoLat?: string;
  geoLon?: string;
  radius?: number;
  radiusUnits?: string;
}

export interface Disaster {
  disasterId?: number;

  name?: string;
  // HTML-friendly description of disaster impact, history, etc.
  summary?: string | SafeHtml;
  // date in format `YYYY-MM-DD`
  dateOfDisaster?: string;
  // see endpoint get /admin/disaster_type for valid values
  disasterType?: string;

  // one to many relationship between disaster and services provided
  // represents services needed in response to disaster
  services?: Service[];

  locations?: DisasterCountry[];

  moneyRaised?: number;
  percentageSpent?: number;
  workersOnTheGround?: number;

  respondingOrgs?: any[];

  // one of Tall, Grande or Venti. for use in specifying how often DSS are required
  notificationTrack?: string;

  // for use in displaying the "starred" organizations in the home page. lower priority = higher in the list.
  priority?: number;

  // URI to display current logo, logoId for setting a new logo (logoId returned from uploading separately)
  logoURI?: string;
  logo?: {
    fileId?: number;
    uri?: string;
  };
  disasterLogo?: {
    fileId?: number;
    uri?: string;
  };

  addedDate?: string | number | Date;

  // array of strings to be used for searching for disasters in the home page
  searchTerms?: string[];
  // disaster hashtag
  disasterHashtag?: string;

  // flag that decides whether to use DSS or LSS in disaster-about page
  displayDss?: boolean;

  // Indicates whether disaster is global or not
  global?: boolean;

  // flag that indicates whether disaster is inactive/archived
  inactive?: boolean;

  // for use with social media sharing buttons
  metadata?: string;

  createDate?: number | Date;

  disasterLocations?: string[];
}
